/**
 * Single entry point for authentication in the app.
 *
 * Chooses the implementation at build time from REACT_APP_AUTH_MODE:
 *   hosted  → Cognito Hosted UI via react-oidc-context (legacy behaviour)
 *   custom  → SPA-owned pages via amazon-cognito-identity-js (Etapa A)
 *
 * Every component should import { useAuth, AuthProvider } from here instead
 * of from "react-oidc-context", so the switch is transparent to call sites.
 */
import React from "react";
import PropTypes from "prop-types";
import { AuthProvider as OidcProvider, useAuth as useOidcAuth } from "react-oidc-context";
import config from "../config/env";
import { CustomAuthProvider, useCustomAuth } from "./CustomAuthProvider";

export const IS_CUSTOM_AUTH = config.AUTH_MODE === "custom";

const oidcConfig = {
  authority: config.COGNITO_AUTHORITY,
  client_id: config.COGNITO_CLIENT_ID,
  redirect_uri: config.APP_URL,
  response_type: "code",
  scope: "email openid phone aws.cognito.signin.user.admin",
  extraQueryParams: { lang: "pt-BR" },
};

const HostedProvider = ({ children }) => <OidcProvider {...oidcConfig}>{children}</OidcProvider>;
HostedProvider.propTypes = { children: PropTypes.node };

export const AuthProvider = IS_CUSTOM_AUTH ? CustomAuthProvider : HostedProvider;
export const useAuth = IS_CUSTOM_AUTH ? useCustomAuth : useOidcAuth;
